import React from "react";
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Typography,
  Grid,
} from "@mui/material";

import "./ReportsStyle.css";

import unauthorized_area_alerts from "../../imgs/reports/unauthorized_area_alerts.png";
import driver_behavior_analysis from "../../imgs/reports/driver_behavior_analysis.png";
import real_time_speed_monitoring from "../../imgs/reports/real_time_speed_monitoring.png";
import real_time_location_tracking from "../../imgs/reports/real_time_location_tracking.png";
import fuel_consumption_reports from "../../imgs/reports/fuel_consumption_reports.png";
import maintenance_alerts from "../../imgs/reports/maintenance_alerts.png";
import emergency_button_shutdown from "../../imgs/reports/emergency_button_shutdown.png";
import mobile_app_tracking_reports from "../../imgs/reports/mobile_app_tracking_reports.png";
import { t } from "i18next";

const repItemsImgs = {
  unauthorized_area_alerts: unauthorized_area_alerts,
  driver_behavior_analysis: driver_behavior_analysis,
  real_time_speed_monitoring: real_time_speed_monitoring,
  real_time_location_tracking: real_time_location_tracking,
  fuel_consumption_reports: fuel_consumption_reports,
  maintenance_alerts: maintenance_alerts,
  emergency_button_shutdown: emergency_button_shutdown,
  mobile_app_tracking_reports: mobile_app_tracking_reports,
};
function FmsReports() {
  const reportItems = t("fms_reports_items", { returnObjects: true });
  return (
    <Box
      className="rep-container"
      sx={{
        paddingInline: { xs: "10px", md: "150px", lg: "200px" },
      }}
    >
      <Box className="rep-header">
        <h2 className="oz-subtitle"> {t("fms_reports_title")} </h2>
        <p className="oz-paragraph">{t("fms_reports_content1")}</p>
        <p className="oz-paragraph">{t("fms_reports_content2")}</p>
      </Box>
      <Box className="rep-cards">
        <Grid container spacing={2} className="rep-card-container">
          {Object.entries(reportItems).map(([index, card]) => (
            <Grid item xs={6} sm={6} md={4} lg={3} key={index}>
              <Card elevation={0} className="rep-card">
                <CardMedia
                  component="img"
                  className="rep-card-media"
                  image={repItemsImgs[card.image]}
                  alt={`Card image ${index + 1}`}
                />
                <CardContent className="rep-card-content">
                  <p className="oz-paragraph">{card.text}</p>
                  {/* <Typography variant="body2" color="text.secondary">
                    {card.phrase2}
                  </Typography> */}
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
}

export default FmsReports;
